/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import Paging from "./Paging";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Alert from "./Alert";
import { SidebarGlobal } from "./_Sidebar";

class MarketingPartners extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loaded: false,
            loading: true,
            pageCount: 0,
            page: props.params ? props.params.page ?? 1 : 1
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/marketing-partner/new')}><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline">New Marketing Partner</span></button>
            <button type="button" className="btn btn-primary" onClick={() => this.load()}><FontAwesomeIcon icon={fa.faRefresh} /> <span className="d-none d-md-inline">Refresh</span></button>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.page !== this.props.params.page) {
            this.state.page = Number(this.props.params.page);
            this.setState({ query: this.state.query });
            this.load();
        }
    }

    load() {
        this.setState({ loading: true });
        qreq.get('/api/account/marketing-partner/list', j => {
            if (j.list)
                this.setState({ list: j.list, pageCount: j.pageCount });
            else if (j.errorCode !== 0)
                this.setState({ errorMessage: j.errorMessage });
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    render() {
        const header = (<h1>Marketing Partners</h1>);
        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            <DataTable columns={[
                { icon: 'Eye', link: '/marketing-partner/edit/:id' },
                { name: 'id', title: 'ID', link: '/marketing-partner/edit/:id' },
                { name: 'name', title: 'Partner', link: '/marketing-partner/edit/:id' },
                { name: 'status', title: 'Status' },
                { name: 'createdDate', title: 'Created', format: 'datetime' }
            ]} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                { name: 'status', title: 'Status', filter: 'Status', type: 'select', options: this.state.statusList },
                { name: 'createdDate', title: 'Created Date', filter: 'CreatedDate', type: 'daterange' }
            ]} showFilters={this.state.showFilters} onFilter={this.onFilter} showCheckboxes={this.state.showFilters} />
            <div className="card-body">
                <Paging baseLoc="/marketing-partner/list/page/" pageCount={this.state.pageCount} currentPage={this.state.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(MarketingPartners);